import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.isVisible
    ? _c(
        "div",
        {
          ref: "bannerEl",
          staticClass:
            "core-cookie-banner d-flex align-center justify-space-between px-4 py-2 bg-primary",
          class: _setup.isMobile ? "core-cookie-banner_mobile" : "rounded",
          attrs: { "data-qa": "cookie-banner", "data-nosnippet": "" },
        },
        [
          _c("div", { staticClass: "text-body-2 text--text" }, [
            _vm._v("\n    Мы используем\n    "),
            _c(
              "a",
              {
                staticClass: "primary--text text-decoration-none",
                attrs: {
                  href: _setup.policyHref,
                  target: "_blank",
                  rel: "noopener noreferrer",
                  "data-qa": "cookie-banner-link",
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_setup.isRussia ? "cookie" : "cookie,") +
                    "\n    "
                ),
              ]
            ),
            _vm._v(
              "\n    " +
                _vm._s(
                  _setup.isRussia
                    ? "и Яндекс.Метрику, чтобы сайт работал лучше"
                    : "чтобы сайт работал лучше"
                ) +
                "\n  "
            ),
          ]),
          _vm._v(" "),
          _c(
            VBtn,
            {
              staticClass: "ml-4 flex-shrink-0",
              attrs: {
                color: "primary",
                depressed: "",
                "data-qa": "cookie-banner-button",
              },
              on: { click: _setup.onAccept },
            },
            [
              _c("span", { staticClass: "text-button" }, [
                _vm._v("\n      Хорошо\n    "),
              ]),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }